import Swal from "sweetalert2";
import { _SWAL_BTN, _SWAL_ICONS } from "./constants";

/**
 * Use to create confirm pop-up
 *
 * Exemple :
 *
 * createConfirm("Voulez vous supprimer cette aide")
 *      .fire({})
 *      .then(result => {
 *          if (result.isConfirmed){
 *              // Traitement
 *          }
 *      })
 *
 * @param question
 * @param options
 * @returns {Swal}
 */
export function createConfirm(question, options = {}) {
  let option = {
    title: question,
    icon: _SWAL_ICONS.question,
    showCancelButton: true,
    confirmButtonText: _SWAL_BTN.Confirm,
    cancelButtonText: _SWAL_BTN.Cancel,
	...options,
  };

  return Swal.mixin(option);
}
